export default __webpack_public_path__ + "static/media/edit.30d6e270.svg";